import URLParser from '../URLParser'

const searchParamIncludesOne = (searchParam, ...expectedValues) => {
  return traffic => {
    const urlObject = new URLParser(traffic.url)
    return expectedValues.some(expValue => {
      const value = urlObject.searchParams.get(searchParam)
      return value !== null && value.includes(expValue)
    })
  }
}

export default searchParamIncludesOne



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/predicates/searchParamIncludesOne.js